import { UPDATE_DOCUMENT_BAR } from '../constants';

export default (
  state = {
    documentId: undefined,
    display: false,
    taskIdResourceIds: [],
    tagTypeId: undefined,
    resourceId: undefined,
    filePrefix: undefined,
    fileExtension: undefined,
    tags: [],
    hasNote: false,
    order_fc_ids: [],
    therapy_ids: [],
    pendingDocument: [],
  },
  { type, payload },
) => {
  switch (type) {
    case UPDATE_DOCUMENT_BAR:
      return { ...state, ...payload };
    case 'SET_PENDING_DOCUMENT': {
      const docs = [...state.pendingDocument, payload];
      return { ...state, pendingDocument: docs };
    }
    default:
      return state;
  }
};
